// Material-ui
import { Modal as ModalContainer, Backdrop, Fade, Box, IconButton, Stack } from '@mui/material';

// Project Import
import { ActionType, ModalProps } from './types';
import { BodyContainer, FooterContainer, HeaderContainer, IconContainer, ModalBox } from './styles';
import CloseIcon from '@mui/icons-material/Close';
import ImdaButton from 'components/button';
import { CONSTANTS } from 'common/constants';
import { useNavigate } from 'react-router-dom';

function Modal({
    title,
    content,
    actions,
    open,
    setOpen,
    secondaryActions,
    status,
    position,
    removeOnBackGroundClose,
    removeCloseIcon,
    customWidth,
    customBodyPadding,
    customHeadingStyle,
    customHeadingStyle2,
    customModalBoxBorderRadius,
    customHeaderContainerPadding,
    closeIconCustomNavigate
}: ModalProps) {
    const handleClose = () => setOpen(false);
    const navigate = useNavigate();
    return (
        <ModalContainer
            open={open}
            keepMounted={false}
            onClose={removeOnBackGroundClose ? undefined : handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500
            }}
            sx={{
                zIndex: 10001
            }}
        >
            <Fade in={open}>
                <ModalBox
                    sx={{
                        maxWidth: {
                            md: customWidth ?? '800px'
                        },
                        '&:focus-visible': { outline: 'unset' },
                        borderRadius: customModalBoxBorderRadius || '0'
                    }}
                >
                    <HeaderContainer
                        sx={{
                            padding: customHeaderContainerPadding || '18px'
                        }}
                    >
                        <Box
                            sx={
                                customHeadingStyle
                                    ? {
                                          margin: 0,
                                          fontSize: '20px',
                                          lineHeight: '24.38px',
                                          color: '#70309F',
                                          fontStyle: 'italic'
                                      }
                                    : customHeadingStyle2
                                    ? {
                                          margin: 0,
                                          fontSize: '20px',
                                          lineHeight: '24.38px',
                                          color: '#70309F'
                                      }
                                    : {
                                          margin: 0,
                                          fontSize: '18px',
                                          color: '#000'
                                      }
                            }
                            component="h3"
                        >
                            {title}
                        </Box>
                        {!removeCloseIcon && (
                            <IconContainer>
                                <IconButton
                                    onClick={() => {
                                        handleClose();
                                        if (closeIconCustomNavigate) {
                                            navigate(closeIconCustomNavigate);
                                        }
                                    }}
                                    data-testid="CloseIconModal"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </IconContainer>
                        )}
                    </HeaderContainer>
                    <BodyContainer
                        sx={{
                            padding: customBodyPadding || '18px',
                            '#label-container': {
                                width: '500px'
                            }
                        }}
                    >
                        {content}
                    </BodyContainer>
                    {!!actions && status !== CONSTANTS.LOADING && (
                        <FooterContainer
                            direction="row"
                            gap={2}
                            sx={{
                                p: {
                                    lg: '1rem',
                                    xs: '0 1rem'
                                },
                                display: 'flex',
                                justifyContent: position || 'flex-end'
                            }}
                        >
                            <Stack
                                spacing={2}
                                flexDirection={{ lg: 'row', xs: 'column-reverse' }}
                                direction={{ lg: 'row', xs: 'column' }}
                                sx={{
                                    width: {
                                        lg: 'unset',
                                        xs: '100%'
                                    }
                                }}
                            >
                                {secondaryActions &&
                                    secondaryActions?.map(
                                        ({ actionText, actionID, actionVariant, actionCallback, actionDisabled }: ActionType) => (
                                            <ImdaButton
                                                id={actionID}
                                                key={actionID}
                                                data-testid={actionID}
                                                btnClass={actionVariant}
                                                onClick={actionCallback}
                                                disabled={actionDisabled}
                                                sx={{
                                                    width: {
                                                        lg: 'unset',
                                                        xs: '100%'
                                                    }
                                                }}
                                            >
                                                {actionText}
                                            </ImdaButton>
                                        )
                                    )}
                                {actions?.map(({ actionText, actionID, actionVariant, actionCallback, actionDisabled }: ActionType) => (
                                    <ImdaButton
                                        id={actionID}
                                        key={actionID}
                                        data-testid={actionID}
                                        btnClass={actionVariant}
                                        onClick={actionCallback}
                                        disabled={actionDisabled}
                                        sx={{
                                            width: {
                                                lg: 'unset',
                                                xs: '100%'
                                            }
                                        }}
                                    >
                                        {actionText}
                                    </ImdaButton>
                                ))}
                            </Stack>
                        </FooterContainer>
                    )}
                </ModalBox>
            </Fade>
        </ModalContainer>
    );
}

export default Modal;
